import request from '@/utils/http'

export function getChatQuota () {
  return request.get({
    url: '/api/ai-quota/chat',
    config: { suppressGlobalError: true }
  })
}
